import { Provider, observer } from 'mobx-react';

import DraftReport from './controls/draft-report';

import React from 'react';

@observer
class Report extends React.Component {
  render() {
    let { store } = this.props;
    if (store.reportTemplateType !== 'D') {
      return null; // markdown reports no longer valid
    }

    return (
      <Provider report={store}>
        <DraftReport {...this.props} />
      </Provider>
    );
  }
}

export default Report;
